export enum RequestType {
  /**
   * Indicates the manifest request.
   */
  MANIFEST,

  /**
   * Indicates that the request is audio/video/text segment.
   */
  SEGMENT,

  /**
   * Indicates the license request.
   */
  LICENSE,
}

/**
 * Passive network filter observation. The timestamp is Unix time in milliseconds.
 * Request and response bodies, headers, and URLs are deliberately excluded.
 */
export interface NetworkRequestObservation {
  requestType: RequestType;
  timestamp: number;
  /** Response payload size in bytes, when provided by the networking engine. */
  bytesTransferred?: number;
  /** Transfer duration in milliseconds, measured by the networking engine. */
  durationMs?: number;
  /** Allowlisted media extension or MIME category, without URL or header data. */
  contentType?: 'mpd' | 'm3u8' | 'm4s' | 'ts' | 'mp4' | 'aac' | 'vtt';
}
